import 'css-chunk:src/app/components/Charts/components/ROI/Tooltip.module.scss';export default {
  "CustomTooltip": "_CustomTooltip_16ry2_1",
  "rowText": "_rowText_16ry2_13",
  "rowCircle": "_rowCircle_16ry2_16",
  "rowDivider": "_rowDivider_16ry2_22"
};